/* eslint-disable */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Reducer } from "redux";
import * as types from "../../Types/common";

import {
  bindCovidAndNriDetails,
  bindGeneralDetailsApiData,
  bindNewLeadDetailsApiData
} from "src/helpers/FormDetails";
import { fileInitialValue } from "src/helpers/FormDetails/CreateDetails";

export interface CommonTypings {
  user: Record<string, any>;
  leadId: string;
  leadDetails: Record<string, any>;
  isPostMEFLoading: boolean;
  isMasterFetching: boolean;
  isRecalculateDone: boolean;
  recalculateError?: string;
  isProportionateLead: boolean;
  isProportionateParentLead: boolean;
  productId?: number;
  staffMember: boolean;
  partnerData: Record<string, any>;
  assignmentStepperFlag: boolean;
  isRiderActive: boolean;
}

const initialState: CommonTypings = {
  user: {},
  leadId: "",
  leadDetails: {},
  isPostMEFLoading: false,
  isMasterFetching: false,
  isRecalculateDone: false,
  recalculateError: "",
  isProportionateLead: false,
  isProportionateParentLead: false,
  staffMember: false,
  partnerData: {},
  assignmentStepperFlag: false,
  isRiderActive: false
};

// eslint-disable-next-line default-param-last
const commonReducer: Reducer<CommonTypings> = (state = initialState, action) => {
  switch (action.type) {
    case types.USER_DATA: {
      const { payload } = action;
      return { ...state, user: payload };
    }
    case types.SET_LEAD_ID: {
      const { payload } = action;
      return { ...state, leadId: payload };
    }
    case types.SET_LEAD_DETAILS: {
      return { ...state, leadDetails: action.payload };
    }
    case types.SET_POST_MEF_LOADING: {
      return { ...state, isPostMEFLoading: action.payload };
    }
    case types.IS_MASTER_LOADING: {
      return { ...state, isMasterFetching: action.payload };
    }
    case types.IS_RECALCULATE_DONE: {
      return { ...state, isRecalculateDone: action.payload };
    }
    case types.SET_RECALCULATE_ERROR: {
      return { ...state, recalculateError: action.payload };
    }
    case types.SET_PROPORTIONATE_LEAD: {
      return { ...state, isProportionateLead: action.payload };
    }
    case types.SET_PROPORTIONATE_PARENT_LEAD: {
      return { ...state, isProportionateParentLead: action.payload };
    }
    case types.SET_PRODUCT_ID: {
      const { payload } = action;
      return { ...state, productId: payload };
    }
    case types.SET_STAFF_MEMBER: {
      const { payload } = action;
      return { ...state, staffMember: payload };
    }
    case types.SAVE_PARTNER_DATA: {
      const { payload } = action;
      return { ...state, partnerData: payload };
    }
    case types.SET_ASSIGNMENT_STEPPER_FLAG: {
      const { payload } = action;
      return { ...state, assignmentStepperFlag: payload };
    }
    case types.SHOW_RIDER_ACTIVE_FLAG: {
      const { payload } = action;
      return { ...state, isRiderActive: payload };
    }
    default:
      return state;
  }
};

const SET_USER_DATA = (
  // eslint-disable-next-line default-param-last
  state: any = {},
  action: { type: string; payload: any }
) => {
  const { type, payload } = action;
  switch (type) {
    case types.SET_USER_DATA:
      return payload;
    default:
      return state;
  }
};

// eslint-disable-next-line default-param-last
const SET_IS_LOGGED_IN = (state: any = false, action: { type: string; payload: any }) => {
  const { type, payload } = action;
  switch (type) {
    case types.SET_IS_LOGGED_IN:
      return payload;
    default:
      return state;
  }
};

// eslint-disable-next-line default-param-last
const SET_JOINT_ADDENDUM_STATE = (
  state: any = {
    isJointState: "no"
  },
  action: { type: string; payload: any }
) => {
  const { type, payload } = action;
  switch (type) {
    case types.SET_JOINT_ADDENDUM_STATE:
      return { ...state, ...payload };
    default:
      return state;
  }
};

const SET_GENERAL_DETAILS = (
  // eslint-disable-next-line default-param-last
  state: any = {
    applicationNumber: "",
    serviceBranchCode: "",
    serviceBranchName: "",
    bankDistributorName: "",
    ageasFederalEmployeeCode: "",
    bankCustomerId: "",
    branchSalesManagerCode: "",
    typeOfLoan: "",
    st1Code: "",
    leadId: "",
    isCoBorrower: false,
    isGuarantor: false,
    isHousewife: false
  },
  action: any
) => {
  switch (action.type) {
    case types.SAVE_GENERAL_DETAILS:
      const data = bindGeneralDetailsApiData(state, action?.payload?.apiData);
      return { ...state, ...data, leadId: action?.payload?.apiData?.id };
    case types.GENERAL_DETAILS: {
      return { ...state, ...action.payload };
    }
    default:
      return state;
  }
};

const SET_COVID_AND_NRI_DETAILS = (
  // eslint-disable-next-line default-param-last
  state: any = {
    covidTest: {
      covidPositive: false,
      covidQuarantine: "",
      covidComplication: ""
    },
    covidVaccineDates: {
      covidVaccinated: true,
      dateOfFirstDose: "",
      dateOfSecondDose: "",
      dateOfBoosterDose: ""
    },
    nriDetails: {
      currentCountry: "India",
      cityOfResidence: "",
      lastDateOfEntryToIn: "",
      exitDateFromIndia: "",
      durationOfStayAbroad: "",
      purposeOfStayAbroad: "",
      insurancePurpose: ""
    },
    otherCountryTravel: {
      isOtherCountryTravel: false,
      countryName: "india",
      duration: "",
      purpose: ""
    },
    occupationDetails: {
      occupationNameAndRole: ""
    },
    salaried: {
      isSalaried: false,
      companyName: "",
      designation: "",
      currency: "Rupee",
      monthlyIncome: ""
    },
    selfEmployed: {
      isSelfEmployed: false,
      grossTurnover: "",
      annualIncome: ""
    },
    bankDetails: { nameOfTheBank: "", branch: "", accountNumber: "" },
    residence: {
      nameOfTheBankResidence: ""
    },
    policyDetails: {
      isOtherPolicyOutsideIndia: false,
      insurerName: "",
      sumAssured: "",
      premiumAccount: "",
      policyStatus: "",
      dateOfInsurance: ""
    },
    leadId: ""
  },
  action: { type: string; payload: any }
) => {
  switch (action.type) {
    case types.SAVE_COVID_AND_NRI:
      const data = bindCovidAndNriDetails(state, action?.payload?.apiData);
      return { ...state, ...data, leadId: action?.payload?.apiData?.id };
    case types.COVID_AND_NRI: {
      return { ...state, ...action.payload };
    }
    default:
      return state;
  }
};

const SET_TOAST_ERROR = (
  // eslint-disable-next-line default-param-last
  state = {
    error: false,
    type: "",
    message: "",
    isTicketRaised: false
  },
  action: any
) => {
  const { type, payload } = action;
  switch (type) {
    case types.TOAST_ERROR:
      return payload;
    default:
      return state;
  }
};

const SET_STEP_DETAILS = (
  state: any = {
    parentStepNo: 1,
    proposerStepNo: 1,
    reviewStepNo: 1,
    jointStepNo: 1
  },
  action: any
) => {
  switch (action.type) {
    case types.STEP_DETAILS:
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
};

const SET_OTP_VERIFICATION_DETAILS = (
  state: any = {
    otpVerificationId: "",
    otpValue: ""
  },
  action: any
) => {
  const { type, payload } = action;
  switch (type) {
    case types.OTP_VERIFICATION_DETAILS:
      return {
        ...state,
        ...payload
      };
    default:
      return state;
  }
};

const SET_VERIFY_OTP_LEAD_ID = (
  state: any = {
    leadId: ""
  },
  action: any
) => {
  const { type, payload } = action;
  switch (type) {
    case types.VERIFY_OTP_LEAD_ID:
      return {
        ...state,
        ...payload
      };
    default:
      return state;
  }
};

const SET_LOAN_STATUS = (
  state: any = {
    loanStatus: ""
  },
  action: any
) => {
  const { type, payload } = action;
  switch (type) {
    case types.LOAN_STATUS:
      return {
        ...state,
        ...payload
      };
    default:
      return state;
  }
};

const SET_MEF_UPLOAD_MODAL = (
  state: any = {
    modalState: false
  },
  action: any
) => {
  const { type, payload } = action;
  switch (type) {
    case types.MEF_UPLOAD_MODAL:
      return {
        ...state,
        ...payload
      };
    default:
      return state;
  }
};

const SET_SIGNATURE_MODAL = (
  state: any = {
    modalState: false
  },
  action: any
) => {
  const { type, payload } = action;
  switch (type) {
    case types.SIGNATURE_MODAL:
      return {
        ...state,
        ...payload
      };
    default:
      return state;
  }
};

const SET_PROPOSAL_STATUS = (
  state: any = {
    status: ""
  },
  action: any
) => {
  const { type, payload } = action;
  switch (type) {
    case types.PROPOSAL_STATUS:
      return {
        ...state,
        ...payload
      };
    default:
      return state;
  }
};

const SET_NEW_LEAD_DETAILS = (
  // eslint-disable-next-line default-param-last
  state: any = {
    productId: "",
    applicationNumber: "",
    bankBranchName: "",
    loanType: "",
    loanAccountNo: "",
    channel: "",
    partnerId: "",
    bankVertical: "",
    solId: "",
    lgCode: "",
    firstName: "",
    middleName: "",
    lastName: "",
    customerDOB: "",
    customerMobileNumber: "",
    customerPAN: "",
    customerEmail: "",
    customerGender: "",
    applicationSignedDate: "",
    loanAmount: "",
    loanTerm: "",
    policyTerm: "",
    premiumPaymentTerm: "",
    loanInterestRate: "",
    sumAssured: "",
    files: [...[fileInitialValue]]
  },
  action: any
) => {
  switch (action.type) {
    case types.SAVE_NEW_LEAD_DETAILS:
      const data = bindNewLeadDetailsApiData(action?.payload?.apiData);
      return { ...state, ...data };
    default:
      return state;
  }
};

export {
  SET_USER_DATA,
  SET_GENERAL_DETAILS,
  SET_IS_LOGGED_IN,
  SET_JOINT_ADDENDUM_STATE,
  SET_COVID_AND_NRI_DETAILS,
  SET_TOAST_ERROR,
  SET_STEP_DETAILS,
  commonReducer,
  SET_OTP_VERIFICATION_DETAILS,
  SET_VERIFY_OTP_LEAD_ID,
  SET_LOAN_STATUS,
  SET_MEF_UPLOAD_MODAL,
  SET_PROPOSAL_STATUS,
  SET_SIGNATURE_MODAL,
  SET_NEW_LEAD_DETAILS
};
